// extracted by mini-css-extract-plugin
export default {"recognize":"recognize_recognize__rbA7P","visualisation":"recognize_visualisation__reZSG"};